import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { LABELS } from "./constants";

interface ModalStateIF {
  visible: boolean;
  title?: string;
  negativeBtn?: string;
  positiveBtn?: string;
  content?: string | JSX.Element;
  positiveFn: VoidFunction;
  negativeFn?: VoidFunction;
}

const initialState = {
  visible: false,
  title: LABELS.TITLE,
  negativeBtn: LABELS.CANCEL,
  positiveBtn: LABELS.OK,
} as ModalStateIF;

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (
      state,
      action: PayloadAction<{
        title?: string;
        negativeBtn?: string;
        positiveBtn?: string;
        content?: string | JSX.Element;
        positiveFn: VoidFunction;
        negativeFn?: VoidFunction;
      }>
    ) => ({ ...current(state), ...action.payload, visible: true }),
    dismissModal: () => ({ ...initialState }),
  },
});

export const { showModal, dismissModal } = modalSlice.actions;

export default modalSlice.reducer;
